import { Injectable } from '@angular/core';
import { Api } from '../../contracts/classes/api.class';
import { CreateTypeTelephoneDTO, TypeTelephone, updateOrderTypeTelephoneDTO, UpdateTypeTelephoneDTO } from '../../contracts/models/type-telephone.model';
import { Observable } from 'rxjs';
import { IResponse } from '../../contracts/models/response.model';

@Injectable({
  providedIn: 'root'
})
export class TypeTelephoneService extends Api {
  getAll(): Observable<IResponse<TypeTelephone[]>> {
    return this.http.get<IResponse<TypeTelephone[]>>(`${this.url}/tipoTelefono`);
  }

  create(createTypeEmailDTO: CreateTypeTelephoneDTO): Observable<IResponse<TypeTelephone>> {
    return this.http.post<IResponse<TypeTelephone>>(`${this.url}/tipoTelefono`, createTypeEmailDTO);
  }

  update(UpdateTypeTelephoneDTO: UpdateTypeTelephoneDTO): Observable<IResponse<TypeTelephone>> {
    return this.http.put<IResponse<TypeTelephone>>(`${this.url}/tipoTelefono/${UpdateTypeTelephoneDTO.id}`, UpdateTypeTelephoneDTO);
  }

  delete(id: number): Observable<IResponse<TypeTelephone>> {
    return this.http.delete<IResponse<TypeTelephone>>(`${this.url}/tipoTelefono/${id}`);
  }

  updateOrder(updateOrderTypeTelephoneDTO: updateOrderTypeTelephoneDTO[]): Observable<IResponse<TypeTelephone[]>> {
    return this.http.put<IResponse<TypeTelephone[]>>(`${this.url}/tipoTelefono/data/updateOrder`, {
      tipoTelefonos: updateOrderTypeTelephoneDTO
    });
  }
}
